export default __webpack_public_path__ + "static/media/business.0d116b17.svg";